"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIDEO_WEBSOCKET_SERVER_OPTIONS = exports.getDefaultVideoEncodingsParameters = exports.LOW_QUALITY_LAYER_VIDEO_FRAMERATE = exports.MID_QUALITY_LAYER_VIDEO_FRAMERATE = exports.HIGH_QUALITY_LAYER_VIDEO_FRAMERATE = exports.HIGH_QUALITY_LAYER_VIDEO_BITRATE = exports.MID_QUALITY_LAYER_VIDEO_BITRATE = exports.LOW_QUALITY_LAYER_VIDEO_BITRATE = exports.DEFAULT_VIDEO_CAPTURE_FPS = exports.DEFAULT_VIDEO_CAPTURE_HEIGHT = exports.DEFAULT_VIDEO_CAPTURE_WIDTH = void 0;
exports.DEFAULT_VIDEO_CAPTURE_WIDTH = 1280;
exports.DEFAULT_VIDEO_CAPTURE_HEIGHT = 720;
exports.DEFAULT_VIDEO_CAPTURE_FPS = 24;
exports.LOW_QUALITY_LAYER_VIDEO_BITRATE = 120000;
exports.MID_QUALITY_LAYER_VIDEO_BITRATE = 350000;
exports.HIGH_QUALITY_LAYER_VIDEO_BITRATE = 1500000;
exports.HIGH_QUALITY_LAYER_VIDEO_FRAMERATE = 24;
exports.MID_QUALITY_LAYER_VIDEO_FRAMERATE = 24;
exports.LOW_QUALITY_LAYER_VIDEO_FRAMERATE = 18;
const getDefaultVideoEncodingsParameters = (width, height) => {
    const sanitized_width = Math.max(width ?? exports.DEFAULT_VIDEO_CAPTURE_WIDTH, height ?? exports.DEFAULT_VIDEO_CAPTURE_HEIGHT);
    if (sanitized_width === exports.DEFAULT_VIDEO_CAPTURE_WIDTH) {
        return [
            {
                maxBitrate: exports.LOW_QUALITY_LAYER_VIDEO_BITRATE,
                maxFramerate: exports.LOW_QUALITY_LAYER_VIDEO_FRAMERATE,
                scaleResolutionDownBy: 4,
                scalabilityMode: "L1T2",
            },
            {
                maxBitrate: exports.MID_QUALITY_LAYER_VIDEO_BITRATE,
                maxFramerate: exports.MID_QUALITY_LAYER_VIDEO_FRAMERATE,
                scaleResolutionDownBy: 2,
                scalabilityMode: "L1T2",
            },
            {
                maxBitrate: exports.HIGH_QUALITY_LAYER_VIDEO_BITRATE,
                maxFramerate: exports.HIGH_QUALITY_LAYER_VIDEO_FRAMERATE,
                scaleResolutionDownBy: 1,
                scalabilityMode: "L1T2",
            },
        ];
    }
    else if (sanitized_width === exports.DEFAULT_VIDEO_CAPTURE_WIDTH / 2) {
        return [
            {
                maxBitrate: exports.LOW_QUALITY_LAYER_VIDEO_BITRATE,
                maxFramerate: exports.LOW_QUALITY_LAYER_VIDEO_FRAMERATE,
                scaleResolutionDownBy: 2,
                scalabilityMode: "L1T2",
            },
            {
                maxBitrate: exports.MID_QUALITY_LAYER_VIDEO_BITRATE,
                maxFramerate: exports.MID_QUALITY_LAYER_VIDEO_FRAMERATE,
                scaleResolutionDownBy: 1,
                scalabilityMode: "L1T2",
            },
        ];
    }
    else {
        return [
            {
                maxBitrate: exports.LOW_QUALITY_LAYER_VIDEO_BITRATE,
                maxFramerate: exports.LOW_QUALITY_LAYER_VIDEO_FRAMERATE,
                scaleResolutionDownBy: 1,
                scalabilityMode: "L1T2",
            },
        ];
    }
};
exports.getDefaultVideoEncodingsParameters = getDefaultVideoEncodingsParameters;
exports.VIDEO_WEBSOCKET_SERVER_OPTIONS = {
    cors: {
        origin: [
            /^https?:\/\/gather.town$/,
            /\.gather\.town$/,
            /^http:\/\/localhost:\d+$/,
        ],
        methods: ["GET", "POST"],
    },
    pingTimeout: 10000,
    pingInterval: 5000,
    transports: ["websocket"],
};
//# sourceMappingURL=settings.js.map